import { render } from "./page-settings.vue?vue&type=template&id=469f0792"
import script from "./page-settings.vue?vue&type=script&lang=js"
export * from "./page-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__